import { envs } from '../lib/constants';
import { cn } from '../lib/utils';
import Logo from './Logo';
import { Separator } from './ui/separator';

export default function FacilityLogo({
  facility_logo,
  business_unit_logo,
  alignment,
}: {
  facility_logo?: string;
  business_unit_logo?: string;
  alignment?: 'start' | 'center';
}) {
  return (
    <div
      className={cn(
        'flex h-full w-full items-center gap-4',
        alignment === 'center' ? 'justify-center' : 'justify-start',
      )}
    >
      {facility_logo && (
        <div className='flex h-full w-max grow items-center justify-center'>
          <Logo text='Company logo' src={envs.ASSETS_URL + facility_logo} />
        </div>
      )}
      {facility_logo && business_unit_logo && (
        <Separator orientation='vertical' className='h-8' />
      )}
      {business_unit_logo && (
        <div className='flex h-full w-max grow items-center justify-center'>
          <Logo
            text='Company logo'
            src={envs.ASSETS_URL + business_unit_logo}
          />
        </div>
      )}
    </div>
  );
}
